// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1 tid="headerText">Update Default Payment Method</h1>
        </div>
        <div class="hoa-dialog__main">
            <p tid="paragraphText">Do you want to update all existing payments and payment schedules with this
                new default payment method?</p>
            <p>Please note, changing the default payment method on existing payments or schedules may result in
                a different convenience fee.
                Only schedules that do not have a pending payment may be modified.</p>
            <div *ngFor="let paymentSchedule of data.paymentSchedules"
                 class="HOA-flextable-component HOA-flextable-component__cell-100 HOA-payment-schedule-hrule-last__parent">
                <div class="HOA-flex-component HOA-flextable-component__cell-100 u-mH4">
                    <div class="HOA-payment-schedule__cell HOA-flextable-component__cell-value"
                         tid="scheduleNickname" id="scheduleNickname">
                        {{paymentSchedule.nickname }}
                    </div>
                </div>
            </div>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button class="Button Button--blue Button--minWidth130 Button--textWrap"
                    tid="yes"
                    (click)="closeThisDialog('Update')">
                {{data.type}} and Update Payment Schedules
            </button>
            <br>
            <button style="margin-left: 0;"
                    class="Button Button--blue Button--minWidth130 Button--textWrap"
                    tid="yes"
                    (click)="closeThisDialog('Save')">
                Just {{data.type}} without Updating Payment Schedules
            </button>
            <br>
            <button class="Button Button--link Button--minWidth130" tid="cancel" (click)="closeThisDialog(0)">
                Cancel
            </button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;